import { lazy, Suspense, useEffect } from "react";
import { applyTheme } from "./utils/theme";
import { Routes, Route, BrowserRouter } from "react-router";
import { SWRConfig } from "swr";
import DefaultLayout from "./layouts/default";
import SwrLocalStorageProvider from "./utils/swr-local-storage-provider";
import useFetcher from "./hooks/use-fetcher";

const Home = lazy(() => import("./views/home/home"));
const CardDetails = lazy(() => import("./views/card-details/card-details"));
const SetOverview = lazy(() => import("./views/set-overview/set-overview"));
const AddSet = lazy(() => import("./views/add-set/add-set"));
const Search = lazy(() => import("./views/search/search"));
const AbundantCards = lazy(
  () => import("./views/abundant-cards/abundant-cards")
);

function App() {
  const fetcher = useFetcher();

  useEffect(() => {
    applyTheme();
  }, []);

  return (
    <BrowserRouter>
      <SWRConfig value={{ fetcher, provider: SwrLocalStorageProvider }}>
        <Suspense fallback={<>Loading...</>}>
          <Routes>
            <Route element={<DefaultLayout />}>
              <Route index element={<Home />} />
              <Route
                path="sets/:setId/cards/:cardId"
                element={<CardDetails />}
              />
              <Route path="sets/:setId" element={<SetOverview />} />
              <Route path="search/:name" element={<Search />} />
              <Route path="abundant-cards" element={<AbundantCards />} />
              <Route path="add-set" element={<AddSet />} />
            </Route>
          </Routes>
        </Suspense>
      </SWRConfig>
    </BrowserRouter>
  );
}

export default App;
